Auth = require 'db/auth'
MemberCardsBoardsSectionView = require 'views/member/member-cards-boards-section-view'
ModelLoader = require 'db/model-loader'
React = require 'react'
ReactWrapper = require 'lib/react/backbone-view-wrapper'
_ = require 'underscore'
l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')()
track = require 'debug/track'

module.exports = class TeamCardsAssignedContainer extends React.Component
  displayName: 'TeamCardsAssignedContainer'

  constructor: (props) ->
    super props

    @state =
      cards: []
      boards: []
      loading: true

  componentDidMount: ->
    ModelLoader.loadOrgMemberCardData(@props.orgId, Auth.me().id)
    .then (cards) =>
      boards = _.chain(cards)
        .map (card) -> card.getBoard()
        .uniq()
        .compact()
        .sortBy (board) -> board.get('name').toLowerCase()
        .sortBy (board) -> if board.isStarred() then 0 else 1
        .value()

      @setState
        cards: cards
        boards: boards
        loading: false

  render: t.renderable ->
    { modelCache, orgId } = @props
    { cards, boards, loading } = @state
    trackObj = {
      category: 'home'
      method: 'by clicking card in assigned cards tab'
      context: { teamId: orgId }
    }

    t.div ->
      if loading
          t.span '.spinner.centered'
      else if boards.length > 0
        for board in boards
          boardCards = _.filter(cards, (card) => card.get('idBoard') == board.id)
          key = _.chain(boardCards).pluck('id').sort().value().join(',')
          view = new MemberCardsBoardsSectionView({ model: board, cards: boardCards, modelCache, trackObj })
          if !_.isEmpty(boardCards)
            t.addElement React.createElement ReactWrapper, { key, view, scope: 'default' }
      else
        t.p { class: 'empty-list gutter', style: { padding: '60px 10px' } }, ->
          t.text l('no assigned cards.at all')



// WEBPACK FOOTER //
// ./app/scripts/views/home/team-cards-assigned-container.coffee